import { Component, inject, input, OnInit, output, signal } from '@angular/core';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzIconModule } from 'ng-zorro-antd/icon';
import {
  I18nService,
  GLOBAL_CONSTANT,
  I18N_KEYS,
  Icons,
  OverlayCardItemComponent,
  NavButtonComponent,
  Images,
} from '@lp-ui-lib';
// import { OverlayCardItem } from '../../../models/interfaces/overlay-card.interface';

@Component({
  selector: 'app-sensor-instruction',
  imports: [NzModalModule, NzIconModule, OverlayCardItemComponent, NavButtonComponent],
  templateUrl: './sensor-instruction.html',
  styleUrls: ['./sensor-instruction.scss'],
})
export class SensorInstructionComponent implements OnInit {
  public i18n = inject(I18nService);
  modalOpen = input<boolean>(false);
  public closeButton = output<void>();

  sensorInstructionData = signal<any[]>([]);

  ngOnInit(): void {
    this.sensorInstructionData.set([
      {
        text: this.i18n.langString(I18N_KEYS.OVERVIEW),
        bold: true,
        icon: null,
        hidden: false,
        image: null,
      },
      {
        text: this.i18n.langString(I18N_KEYS.BEFORE_START),
        bold: false,
        icon: null,
        hidden: false,
        image: null,
      },
      {
        text: this.i18n.langString(I18N_KEYS.VERIFY_APPLICATION),
        bold: false,
        icon: null,
        hidden: false,
        image: null,
      },
      {
        text: GLOBAL_CONSTANT.EMPTY_STRING,
        bold: false,
        icon: null,
        hidden: false,
        image: null,
      },
      {
        text: this.i18n.langString(I18N_KEYS.REPAIR_PROCESS),
        bold: false,
        icon: null,
        hidden: false,
        image: null,
      },
      {
        text: GLOBAL_CONSTANT.EMPTY_STRING,
        bold: false,
        icon: null,
        hidden: false,
        image: null,
      },
      {
        text: this.i18n.langString(I18N_KEYS.PLAN_THE_PROCESS),
        bold: false,
        icon: null,
        hidden: false,
        image: null,
      },
      {
        text: this.i18n.langString(I18N_KEYS.ACCESSIBILITY_REPAIR_AREA),
        bold: false,
        icon: null,
        hidden: false,
        image: null,
      },
      {
        text: this.i18n.langString(I18N_KEYS.REQUIRED_TOOLS),
        bold: false,
        icon: null,
        hidden: false,
        image: null,
      },
      {
        text: this.i18n.langString(I18N_KEYS.ENVIRONMENT_CONDITION),
        image: Images.REPAIR_INSTRUCTION,
        bold: false,
        icon: null,
        hidden: false,
      },
      {
        text: this.i18n.langString(I18N_KEYS.OPERATION_MANUAL),
        icon: Icons.HELP,
        bold: false,
        hidden: false,
        image: null,
      },
      {
        text: this.i18n.langString(I18N_KEYS.SENSOR_INSTRUCTION_CNT1),
        icon: Icons.STAT_EXPLANATION_TRIANGLE,
        bold: false,
        hidden: false,
        image: null,
      },
      {
        text: this.i18n.langString(I18N_KEYS.SENSOR_INSTRUCTION_CNT2),
        icon: Icons.STAT_EXPLANATION_TRIANGLE,
        bold: false,
        hidden: false,
        image: null,
      },
      { text: '.', hidden: true, bold: false, icon: null, image: null },
      {
        text: this.i18n.langString(I18N_KEYS.SENSOR_INSTRUCTION_CNT3),
        bold: false,
        icon: null,
        hidden: false,
        image: null,
      },
      {
        text: this.i18n.langString(I18N_KEYS.SENSOR_INSTRUCTION_CNT4),
        image: Images.REPAIR_INSTRUCTION2,
        bold: false,
        icon: null,
        hidden: false,
      },
      {
        text: this.i18n.langString(I18N_KEYS.SENSOR_INSTRUCTION_CNT5),
        bold: false,
        icon: null,
        hidden: false,
        image: null,
      },
      {
        text: this.i18n.langString(I18N_KEYS.SENSOR_INSTRUCTION_CNT6),
        bold: false,
        icon: null,
        hidden: false,
        image: null,
      },
      {
        text: this.i18n.langString(I18N_KEYS.SENSOR_INSTRUCTION_CNT7),
        bold: false,
        icon: null,
        hidden: false,
        image: null,
      },
      {
        text: this.i18n.langString(I18N_KEYS.SENSOR_INSTRUCTION_CNT8),
        bold: false,
        icon: null,
        hidden: false,
        image: null,
      },
      {
        text: this.i18n.langString(I18N_KEYS.SENSOR_INSTRUCTION_CNT9),
        icon: Icons.STAT_EXPLANATION_TRIANGLE,
        bold: false,
        hidden: false,
        image: null,
      },
      {
        text: this.i18n.langString(I18N_KEYS.SENSOR_INSTRUCTION_CNT10),
        bold: false,
        icon: null,
        hidden: false,
        image: null,
      },
      {
        text: this.i18n.langString(I18N_KEYS.SENSOR_INSTRUCTION_CNT11),
        icon: Icons.STAT_EXPLANATION_TRIANGLE,
        image: Images.REPAIR_INSTRUCTION,
        bold: false,
        hidden: false,
      },
    ]);
  }

  cancelClick(): void {
    this.closeButton.emit();
  }
}
